export default __webpack_public_path__ + "static/media/cloud-active.a94e033f.svg";